export const NotificationSources = {
    QUERIES: "queries",
    ORIENTATION: "orientation",
    GAMIFICATION: "gamification",
    CHECKOUT: "checkout",
    CONSULTATION: "consultations-api",
    ESSAY: "essay-api",
};
export const NotificationFormats = {
    DOCKED: "DOCKED",
    TOAST: "TOAST",
    MODAL: "MODAL",
};
export const NotificationSortDirections = {
    ASC: "asc",
    DESC: "desc",
};
//# sourceMappingURL=types.js.map